import { Pipe, PipeTransform } from '@angular/core';
import { PortfolioManagement } from '../models/portfolioManagement.model';
@Pipe({
  name: 'policyFilter'
})
export class PolicyFilterPipe implements PipeTransform {
  transform(items: PortfolioManagement[], searchText: string): any[] {
    if(!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase().replace(/[\W_]/g, '');
    
    return items.filter(it => {

      return it.idPortfolio.toString().toLowerCase().includes(searchText);
    });
   }
}
